import { createSlice } from "@reduxjs/toolkit";
import { login } from "../../services/autenticacion.service";

const initialState = {
  nombre: "",
  apellido: "",
  token: "",
  rol: "",
  id: "",
  username: "",
  sexo: "",
  imagen: "",
}

const usuarioSlice = createSlice({
  name: "usuario",
  initialState: localStorage.getItem("userInfoES") ? JSON.parse(localStorage.getItem("userInfoES")) : initialState,
  reducers: {
    loginSlice: (state, action) => {
      const data = {
        nombre: action.payload.nombre,
        apellido: action.payload.apellido,
        token: action.payload.token,
        rol: action.payload.rol,
        id: action.payload.id,
        username: action.payload.username,
        sexo: action.payload.sexo || "",
        imagen: action.payload.imagen || "",
        loginTimestamp: Date.now(), // Guardar timestamp del login

      }
      const newData = { ...state, ...data }
      localStorage.setItem("userInfoES", JSON.stringify(newData))
      return newData
    },
    actualizarPerfilSlice: (state, action) => {
      const data = {
        ...state,
        nombre: action.payload.nombre || state.nombre,
        apellido: action.payload.apellido || state.apellido,
        sexo: action.payload.sexo || state.sexo,
        imagen: action.payload.imagen !== undefined ? action.payload.imagen : state.imagen,
      }
      localStorage.setItem("userInfoES", JSON.stringify(data))
      return data
    },
    cerrarSesion: () => {
      localStorage.removeItem("userInfoES")
      return initialState
    }
  }
})

export const { loginSlice, actualizarPerfilSlice, cerrarSesion } = usuarioSlice.actions
export default usuarioSlice.reducer

export const loginThunk = (data, navigate) => async (dispatch) => {
  // await login(data).then((response) => { dispatch(loginSlice(response)); navigate("/inicio"); }).catch((err) => console.log(err))
  try {
    const response = await login(data);
    dispatch(loginSlice(response));
    navigate("/inicio");
  } catch (err) {
    throw err
  }
}


